/**
 * 客户端消息 id：乐观 UI 与 ACK 归并的匹配键（服务端原样回显，见 story §架构契约 2d）。
 * 优先用 crypto.randomUUID（浏览器 + 现代 Node 均有），无则退化到时间戳 + 随机数。
 */
export function generateClientMsgId(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID();
  }
  // 退化：足够唯一即可（仅用于匹配自身的乐观气泡）。
  return `cmid-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
